// Frequently Bought Together (FBT)
// Comprados juntos frecuentemente
import {
    Box, Checkbox, Autocomplete, TextField, Popper
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CustomPopper = styled(Popper)({
    '& .MuiPaper-root': {
        boxShadow: '0px 8px 25px rgba(0,0,0,0.35)',
    }
});

const ProductFBT = ({ allProducts, setAllProducts }) => {
    const handleAutocompleteChange = (event, i) => {
        setAllProducts(currentProducts =>
            currentProducts.map(prod => ({
                ...prod,
                checked: i.some(sel => sel.prod_var_id === prod.prod_var_id)
            }))
        );
    };

    return (
        <Box>
            <Autocomplete
                multiple
                disablePortal
                disableCloseOnSelect
                options={allProducts}
                getOptionLabel={(option) => option.title}
                value={allProducts.filter(i => i.checked)}
                onChange={handleAutocompleteChange}
                PopperComponent={CustomPopper}
                renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={key} {...optionProps}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.title}
                        </li>
                    );
                }}
                sx={{
                    width: '100%',
                    '& .MuiChip-root': {
                        backgroundColor: '#465fff', // tu color
                        color: '#fff',
                        '& .MuiChip-deleteIcon': {
                            color: '#fff',
                        }
                    }
                }}
                renderInput={
                    (params) => <TextField {...params} placeholder="Buscar productos"
                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                    />
                }
            />
        </Box>
    );
};

export default ProductFBT;